import { ISupplierChangeStatus } from "models/CSDIntegration/CSDIntegrationModel";
import { BaseService } from "./base.service";

class SupplierChangeStatusServiceInternal extends BaseService {
	getSupplierChangeStatusList = async (): Promise<ISupplierChangeStatus[]> =>
		this.callApi<ISupplierChangeStatus[]>(
			`SupplierDetailChangeStatus/GetSupplierDetailChangeStatusList`,
			"GET"
		);
}

export const SupplierChangeStatusService =
	new SupplierChangeStatusServiceInternal();
